import { ReactNode } from 'react';

import { Flex, Text } from '@iwoca/orion';

export const LoanSummaryRow = ({
    label,
    value
}: {
    label: ReactNode;
    value: ReactNode;
}) => (
    <Flex align="center" justify="between">
        <Text>{label}</Text>
        <Text className="font-bold">{value}</Text>
    </Flex>
);
